import React, { useEffect, useRef, useState } from "react";
import Nav from "react-bootstrap/Nav";
import { useLocation, Link } from "react-router-dom";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import './FilletTabs.scss';

const FilletTabs = () => {
  const location = useLocation();
  const navRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);

  const userDetails = localStorage.getItem("userDetails");
  const userRole = userDetails ? JSON.parse(userDetails) : null;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsSticky(!entry.isIntersecting);
      },
      { threshold: 1.0 }
    );

    if (navRef.current) observer.observe(navRef.current);
    return () => observer.disconnect();
  }, []);

  const isDisabled = (tabName) => {
    if (tabName === "QCP" && userRole?.role === "CCPInspector") return true;
    if (tabName === "CCP" && userRole?.role === "QCPInspector") return true;
    if (["Overview", "Intake", "Statistics", "Monitor"].includes(tabName)) {
      return userRole?.role === "QCPInspector" || userRole?.role === "CCPInspector";
    }
    return false;
  };

  const tabs = [
    { name: "Overview", path: "/quality/fillet/overview" },
    { name: "Intake", path: "/quality/fillet/intake" },
    { name: "Statistics", path: "/quality/fillet/statistics" },
    { name: "Monitor", path: "/quality/fillet/monitor" },
    {
      name: "QCP",
      path: `${userRole?.role === "QCPInspector" ? "/quality/fillet/qcp" : "/quality/fillet/qcp/view/overview"}`,
      checkStartsWith: "/quality/fillet/qcp",
    },
    {
      name: "CCP",
      path: `${userRole?.role === "CCPInspector" ? "/quality/fillet/ccp" : "/quality/fillet/ccp/view/overview"}`,
      checkStartsWith: "/quality/fillet/ccp",
    },
  ];

  return (
    <>
      <div ref={navRef} className="nav-placeholder" />
      <div className={`fillet-tabs-wrapper ${isSticky ? "is-sticky dark-bg" : ""}`}>
        <Nav variant="underline" className="border-b" activeKey={location.pathname}>
          {tabs.map(({ name, path, checkStartsWith }) => {
            const disabled = isDisabled(name);
            const active = checkStartsWith ? location.pathname.startsWith(checkStartsWith) : undefined;

            const link = (
              <Nav.Link
                as={Link}
                to={path}
                disabled={disabled}
                eventKey={path}
                active={active}
                className="position-relative"
              >
                {name}
              </Nav.Link>
            );

            return (
              <Nav.Item key={name}>
                {disabled ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`tooltip-${name}`}>Not Authorized</Tooltip>}
                  >
                    <div style={{ display: "inline-block", cursor: "not-allowed" }}>
                      {link}
                    </div>
                  </OverlayTrigger>
                ) : (
                  link
                )}
              </Nav.Item>
            );
          })}
        </Nav>
      </div>
    </>
  );
};

export default FilletTabs;
